import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { InspectionCornSchema, InspectionEntityCornSchema, VideoCornSchema } from '../base.js';
export const ShareVideoApiSchema = {
    params: z.object({
        entityId: InspectionEntityCornSchema,
        inspectionId: InspectionCornSchema,
        videoId: VideoCornSchema,
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    response: z.object({ shareLink: z.url() }),
};
export const ShareVideoRequestSchema = ShareVideoApiSchema.params.merge(ShareVideoApiSchema.headers);
